import { ReactElement } from 'react';
import { ExactDateFilter } from '@root/src/app/designSystem/dateFilter';
import SearchInput from '@root/src/app/designSystem/searchInput';
import { dayjs } from '../../utils';
import DataTiles from './dataTile/dataTiles';
import {
  DesktopFilterContainer,
  DesktopFlexRowContainer,
  FiltersContainer,
} from './styles';
import { FilterBarComponentI } from '.';
import Button from '@designSystem/buttons/index';
import { DownloadIcon } from '@root/src/assets/images';
import useOrdersFilters from '@app/healthcheck/filterBar/useOrdersFilters';
import Lang from '@lang/en';
import generateLinkForDownloadCSVFile from './downloadCSVFile';
import { StatsI } from './types';

export const FilterBarDesktop = ({
  stats,
  selectedStartDate,
  isActive,
  ordersStateChange,
  ordersState,
  searchText,
  onChangeSearchText,
  onSetFilterDate,
  typeFilterOptions,
  handleChangeTestFilter,
  currentTestFilterOption,
}: FilterBarComponentI): ReactElement => {
  const { filters } = useOrdersFilters();
  return (
    <>
      <DesktopFlexRowContainer>
        <DataTiles
          stats={stats}
          isActive={isActive}
          ordersStateChange={ordersStateChange}
        />
      </DesktopFlexRowContainer>
      <DesktopFilterContainer>
        <SearchInput
          defaultValue={searchText}
          fixedWidth={240}
          handleSearchChange={onChangeSearchText}
        />
        <FiltersContainer>
          {/* <DropDown
            data-testid="healthcheck-dashboard-testType-filter"
            fixedWidth={225}
            onChange={(option) =>
              handleChangeTestFilter(option?.value as string)
            }
            options={typeFilterOptions}
            beforeText={Lang.healthCheckTestTypeDropdownBeforeText}
            value={currentTestFilterOption}
          /> */}
          <ExactDateFilter
            data-testid="healthcheck-dashboard-date-filter"
            inputWidth={192}
            value={selectedStartDate}
            onDateChange={(value): void => {
              if (!value) {
                onSetFilterDate(null);
                return;
              }
              const date = dayjs(value);
              const formattedDate = date.format('YYYY-MM-DD');
              onSetFilterDate(formattedDate);
            }}
          />
          <Button
            disabled={!stats[ordersState as keyof StatsI]}
            type="secondary"
            icon={<DownloadIcon />}
            label={Lang.exportCSVButtonText}
            as="a"
            href={generateLinkForDownloadCSVFile(filters)}
          />
        </FiltersContainer>
      </DesktopFilterContainer>
    </>
  );
};

export default FilterBarDesktop;
